
import { Component, OnInit, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TreatmentService } from '../../../../api/products/categories/categories.service';
import { QueryParamsFilter } from '../../../../types/gp-address-request-response';
import { GpAddressStatus, GpAddressVerifiedStatus } from '../../../../types/gp-letters';
import { Medication } from '../../../../types/medications';
import { MedicationFilterComponent } from './medication-filter/medication-filter.component';
import { SearchFilterComponent } from './search-filter/search-filter.component';
import { ServiceFilterComponent } from './service-filter/service-filter.component';

export interface EmitFilterChangeParams {
    filter: QueryParamsFilter;
    searchTerm: string;
}

@Component({
    selector: 'gp-letters-filters',
    imports: [
    ServiceFilterComponent,
    FormsModule,
    SearchFilterComponent,
    MedicationFilterComponent
],
    templateUrl: './filters.component.html',
    styleUrl: './filters.component.scss'
})
export class FiltersComponent implements OnInit {
    readonly statusId = input<GpAddressStatus>();
    readonly verified = input<GpAddressVerifiedStatus>();
    readonly filterChanged = output<EmitFilterChangeParams>();
    filter: QueryParamsFilter = {};
    search = '';
    services: TreatmentService[] = [];
    medications: Medication[] = [];

    ngOnInit() {
        this.filter = {
            'gpaddresses.status_id': this.statusId(),
            'orders.service_code:in': '',
            'medications.code:in': '',
        };
        this.filterChanged.emit({ filter: this.filter, searchTerm: this.search });
    }

    searchInputChange($event: string) {
        this.search = $event;
    }

    onClickSearch() {
        this.filterChanged.emit({ filter: this.filter, searchTerm: this.search });
    }

    onServiceFilterChange($event: TreatmentService[]) {
        this.services = [...$event];
        const servicesCodes = $event?.map((service: TreatmentService) => service.code).join(',');
        if (this.filter['orders.service_code:in'] !== servicesCodes) {
            this.filter['orders.service_code:in'] = $event?.map((service: TreatmentService) => service.code).join(',');
            //on empty services event medications.code reset
            if (!servicesCodes.length) {
                this.filter['medications.code:in'] = '';
            }
            this.filterChanged.emit({ filter: this.filter, searchTerm: this.search });
        }
    }

    onMedicationFilterChange($event: Medication[]) {
        this.medications = [...$event];
        const medicationsCodes = $event?.map(med => med.medication_code).join(',');
        if (this.filter['medications.code:in'] !== medicationsCodes) {
            this.filter['medications.code:in'] = $event?.map(med => med.medication_code).join(',');
            this.filterChanged.emit({ filter: this.filter, searchTerm: this.search });
        }
    }
}
